var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"middle-content-last"},[_c('img',{attrs:{"src":_vm.greenCheckCircle,"alt":""}}),_c('h1',[_vm._v("Obrigado por compartilhar seu feedback!")]),_c('button',{on:{"click":_vm.review}},[_vm._v("Ver Minhas Respostas")])])
}
var staticRenderFns = []

export { render, staticRenderFns }